<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
      class="hide-bar"
      v-if="$router.currentRoute.fullPath.indexOf('/login') === -1 && $router.currentRoute.fullPath.indexOf('/work/print') === -1 && $router.currentRoute.fullPath.indexOf('/contracts') === -1"
    >
      <toast />
      <div class="d-flex align-center headline text-uppercase">
        <span>MaxWax</span>
        <span class="font-weight-light ml-2 secondary--text">BOOKING SYSTEM</span>
      </div>

      <v-spacer></v-spacer>

      <v-btn to="/" text>Home</v-btn>
      <v-btn to="/customers" text>Customers</v-btn>
      <v-btn to="/technicians" text>Technicians</v-btn>
      <v-btn to="/scripts" text>Service Descriptions</v-btn>
      <v-btn to="/periods" text>Periods</v-btn>
      <v-btn to="/work" text>Contracts</v-btn>
      <v-btn to="/admin" text>Admin</v-btn>
      <v-btn @click="logout" text>Logout</v-btn>
    </v-app-bar>
    <booking-modal v-if="manageBookingDialog" />
    <customer-modal />
    <technician-modal />
    <delete-technician-modal />
    <period-modal />
    <delete-period-modal />
    <upcoming-repeats-dialog />
    <booking-details-preview-modal />
    <repeat-modal />
    <delete-booking-modal />
    <delete-repeat-modal />
    <delete-contact-modal />
    <script-modal />
    <delete-script-modal />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import BookingModal from "./components/modals/BookingModal";
import Toast from "./components/shared/Toast";
import CustomerModal from "./components/modals/CustomerModal";
import TechnicianModal from "./components/modals/TechnicianModal";
import DeleteTechnicianModal from "./components/modals/DeleteTechnicianModal";
import PeriodModal from "./components/modals/PeriodModal";
import DeletePeriodModal from "./components/modals/DeletePeriodModal";
import {mapMutations, mapState} from "vuex";
import UpcomingRepeatsDialog from "./components/modals/UpcomingRepeatsDialog";
import RepeatModal from "./components/modals/RepeatModal";
import BookingDetailsPreviewModal from "./components/modals/BookingDetailsPreviewModal";
import DeleteBookingModal from "./components/modals/DeleteBookingModal";
import DeleteRepeatModal from "./components/modals/DeleteRepeatDialog";
import DeleteContactModal from "@/components/modals/DeleteContactModal";
import ScriptModal from "@/components/modals/ScriptModal";
import DeleteScriptModal from "@/components/modals/DeleteScriptModal";
export default {
  name: 'App',
  components: {
    DeleteScriptModal,
    ScriptModal,
    DeleteContactModal,
    DeleteRepeatModal,
    DeleteBookingModal,
    BookingDetailsPreviewModal,
    RepeatModal,
    UpcomingRepeatsDialog,
    DeletePeriodModal,
    PeriodModal, DeleteTechnicianModal, TechnicianModal, CustomerModal, Toast, BookingModal},
  computed: {
    ...mapState("bookings", ["manageBookingDialog"]),
  },
  data: () => ({
    //
  }),
  methods: {
    ...mapMutations("app", ["setLoggedIn", "setToken"]),
    async logout(){
      await this.setLoggedIn(false);
      await this.setToken(null);
      window.location.href = "/";
    }
  }
};
</script>

<style>
  @font-face {
    font-family: CharlesWright;
    src: url('assets/fonts/CharlesWright-Bold.ttf');
  }

  .vrm {
    background-color: #F5C445 !important;
    color: black !important;
    font-family: CharlesWright,sans-serif !important;
    padding: 5px !important;
  }

  @media print {
    .hide-bar {
        display: none !important;
    }

    body {
      margin-top: -100px !important;
    }
  }

</style>
